var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 100,
    viewBox: "0 0 40 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "167%",
    height: "151.9%",
    x: "-33.5%",
    y: "-18.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.299142264 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M11.952 0C6.812 0 1.5 3.92 1.5 10.452c0 6.183 9.406 15.851 9.842 16.287.174.174.348.261.61.261.26 0 .435-.087.61-.261.435-.436 9.841-10.016 9.841-16.287C22.403 3.919 17.09 0 11.952 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    height: 100,
    width: 25
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#2F92D0",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.952 13.935c-1.917 0-3.484-1.567-3.484-3.483 0-1.917 1.567-3.484 3.484-3.484 1.916 0 3.483 1.567 3.483 3.484 0 1.916-1.567 3.483-3.483 3.483z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropletIcon);
export default __webpack_public_path__ + "static/media/droplet-icon.3a30f820b917fbe62e35b5a5978c9165.svg";
export { ForwardRef as ReactComponent };